import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * Serializes router URLs with a trailing slash ("/faq" → "/faq/").
 *
 * Firebase Hosting serves the prerendered pages as "<path>/index.html" and
 * answers "<path>" without slash with a 301. Without this serializer every
 * routerLink href points to the redirecting URL, which Search Console reports
 * as "Seite mit Weiterleitung" (#1308). Sitemap, canonical and hreflang already
 * use the slash form (seo.service.ts).
 */
@Injectable()
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
  override serialize(tree: UrlTree): string {
    return withTrailingSlash(super.serialize(tree));
  }
}

/** Appends "/" to the path part, keeping query string and fragment intact. */
export function withTrailingSlash(url: string): string {
  const match = url.match(/^([^?#]*)(.*)$/);
  const path = match?.[1] ?? '';
  const rest = match?.[2] ?? '';
  if (path === '' || path.endsWith('/')) return url;
  return `${path}/${rest}`;
}
